import { useMutation } from "@tanstack/react-query";
import { deleteSchedule } from "../../queries/Schedule";

export const useDeleteScheduleHook = () => {
    const { mutate, data, isError, error, isSuccess, isPending } = useMutation({
        mutationKey: ['delete-actual-user-schedule'],
        mutationFn: (cronogramaId: string) => deleteSchedule(cronogramaId),
        retry: false
    });

    return { mutate, data, isError, error, isSuccess, isPending };
};